/* ============================================================
   HOUSE OF PARVI — THEME JS
============================================================ */

// Shared scroll lock (2026-09-22 fix, finding #7). The nav drawer and
// search overlay (sections/header.liquid) each used to set
// document.body.style.overflow directly with no shared state, so
// closing one could clear a lock the other still needed. Refcounted so
// nesting is safe, and uses the position:fixed + scroll-restore
// technique so it actually holds on iOS Safari (a plain overflow:hidden
// on body does not reliably stop background scroll there).
window.HOPScrollLock = (function() {
  var count = 0;
  var savedY = 0;
  return {
    lock: function() {
      if (count === 0) {
        savedY = window.scrollY || window.pageYOffset || 0;
        document.body.style.position = 'fixed';
        document.body.style.top = '-' + savedY + 'px';
        document.body.style.left = '0';
        document.body.style.right = '0';
        document.body.style.overflow = 'hidden';
      }
      count++;
    },
    unlock: function() {
      count = Math.max(0, count - 1);
      if (count === 0) {
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.left = '';
        document.body.style.right = '';
        document.body.style.overflow = '';
        window.scrollTo(0, savedY);
      }
    }
  };
})();

document.addEventListener('DOMContentLoaded', () => {

  // Announcement bar dismiss lives in sections/announcement-bar.liquid
  // (localStorage, keyed to the message text). Removed the duplicate
  // sessionStorage handler that used to live here — both were bound to
  // the same .announce-close button (2026-09-22 mobile audit, finding #5).

  // ── Nav scroll behaviour ──────────────────────────
  const header = document.querySelector('.site-header');
  const announceBar = document.querySelector('.announce-bar');
  if (header) {
    let lastY = window.scrollY;
    let ticking = false;

    // Always show dark header immediately on all pages including homepage
    header.classList.add('scrolled');

    window.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        const y = window.scrollY;

        header.classList.add('scrolled');

        // Hide / show based on scroll direction
        if (y < 80) {
          // Always show when near the top
          header.classList.remove('nav-hidden');
        } else if (y > lastY + 4) {
          // Scrolling down — slide header out
          header.classList.add('nav-hidden');
        } else if (y < lastY - 4) {
          // Scrolling up — bring header back immediately
          header.classList.remove('nav-hidden');
        }

        lastY = y;
        ticking = false;
      });
    }, { passive: true });
  }

  // ── Scroll reveal ───────────────────────────
  // .r/.rl/.rr start at opacity:0 in base.css and rely entirely on this
  // observer to reveal them — no no-JS fallback existed (2026-09-22
  // audit, finding #12). Guard the setup and force-reveal everything if
  // it's unsupported or throws, so a script error can't blank the page.
  try {
    if (!('IntersectionObserver' in window)) throw new Error('no IO support');
    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) { e.target.classList.add('on'); io.unobserve(e.target); }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
    document.querySelectorAll('.r, .rl, .rr').forEach(el => io.observe(el));
  } catch (err) {
    document.querySelectorAll('.r, .rl, .rr').forEach(el => el.classList.add('on'));
  }

  // ── Cart count update ────────────────────────
  function updateCartCount() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        document.querySelectorAll('.cart-count').forEach(el => {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? 'inline-flex' : 'none';
        });
      });
  }
  updateCartCount();

  // ── Add to cart ───────────────────────────
  // Uses FormData so line-item properties (Monogram, Name, Personalisation Consent)
  // survive to Shopify. JSON body previously dropped every properties[...] field.
  // Dispatches a synthetic submit so per-form validators (monogram consent guard) can run.
  document.querySelectorAll('.add-to-cart').forEach(btn => {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      const form = this.closest('form');
      if (!form) return;
      const variantId = form.querySelector('[name="id"]')?.value;
      if (!variantId) return;
      const submitEvt = new Event('submit', { cancelable: true, bubbles: true });
      const proceed = form.dispatchEvent(submitEvt);
      if (!proceed) return;
      this.textContent = 'Adding…';
      this.disabled = true;
      const fd = new FormData(form);
      if (!fd.has('quantity')) fd.append('quantity', '1');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: fd
      })
      .then(r => r.json())
      .then(() => {
        this.textContent = '✓  Added to Bag';
        this.classList.add('pp-atc-confirming');
        updateCartCount();
        setTimeout(() => {
          this.textContent = 'Add to Bag';
          this.disabled = false;
          this.classList.remove('pp-atc-confirming');
        }, 2400);
      })
      .catch(() => { this.textContent = 'Try Again'; this.disabled = false; });
    });
  });

  // ── Size selector — updates variant ID, price, and stock bar (Issues 3, 9, 13) ──
  document.querySelectorAll('.size-btn').forEach(btn => {
    btn.addEventListener('click', function() {
      this.closest('.size-selector').querySelectorAll('.size-btn').forEach(b => b.classList.remove('active'));
      this.classList.add('active');
      const variantId = this.dataset.variantId;

      // Update hidden variant ID input
      const form = document.querySelector('form[action="/cart/add"]');
      if (form) {
        const input = form.querySelector('[name="id"]');
        if (input) input.value = variantId;

        // Update displayed price and stock bar from embedded variant data
        const raw = form.dataset.variants;
        if (raw) {
          try {
            const variants = JSON.parse(raw);
            const v = variants.find(x => String(x.id) === String(variantId));
            if (v) {
              // Price (Shopify stores in cents — divide by 100 for display)
              const priceEl = document.querySelector('.pp-price');
              if (priceEl) {
                const amount = (v.price / 100).toFixed(2);
                // Use Shopify money format if available, otherwise fallback
                priceEl.textContent = window.Shopify?.formatMoney
                  ? window.Shopify.formatMoney(v.price)
                  : '£' + parseFloat(amount).toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
              }

              // Stock availability bar
              const avail       = document.querySelector('.pp-avail');
              const availLabel  = document.querySelector('.pp-avail-label');
              const availFill   = document.querySelector('.pp-avail-fill');
              const availSub    = document.querySelector('.pp-avail-sub');
              if (avail && v.inventory_quantity !== undefined) {
                const cap = parseInt(avail.dataset.cap) || 10;
                const qty = Math.max(0, v.inventory_quantity);
                const pct = Math.min(100, Math.round(qty * 100 / cap));
                if (qty > 0) {
                  avail.hidden = false;
                  if (availLabel) availLabel.textContent = 'Only ' + qty + ' remaining';
                  if (availFill)  availFill.style.width = pct + '%';
                  if (availSub)   availSub.textContent  = qty + ' of ' + cap + ' pieces remaining';
                } else {
                  avail.hidden = true;
                }
              }

              // Update add-to-cart button state
              const atcBtn = form.querySelector('.add-to-cart');
              if (atcBtn) {
                atcBtn.disabled = !v.available;
                if (!v.available) atcBtn.textContent = 'Sold Out';
                else if (atcBtn.textContent === 'Sold Out') atcBtn.textContent = 'Add to Bag';
              }

              // Sync sticky bar
              var stickyPrice = document.getElementById('pp-sticky-price');
              if (stickyPrice && priceEl) stickyPrice.textContent = priceEl.textContent;
              var stickyAtc = document.getElementById('pp-sticky-atc');
              if (stickyAtc) {
                stickyAtc.disabled = !v.available;
                stickyAtc.textContent = v.available ? 'Add to Bag' : 'Sold Out';
              }

              // Toggle notify-me waitlist form
              var notifyWrap = document.getElementById('pp-notify-wrap');
              if (notifyWrap) {
                notifyWrap.style.display = v.available ? 'none' : '';
                if (v.available) {
                  // Reset form so a new sold-out selection starts fresh
                  var notifyRow = document.getElementById('pp-notify-row');
                  var notifySuccess = document.getElementById('pp-notify-success');
                  if (notifyRow) notifyRow.hidden = false;
                  if (notifySuccess) notifySuccess.hidden = true;
                  var emailInput = notifyWrap.querySelector('.pp-notify-email');
                  if (emailInput) emailInput.value = '';
                }
              }
            }
          } catch(err) { /* invalid JSON — skip update */ }
        }
      }
    });
  });

  // ── Newsletter form — let Shopify handle it natively (Issue 4) ─────────────
  // Native {% form 'customer' %} submits to Shopify and stores the subscriber.
  // Show a success message if the page reloads after a successful submission.
  const nlSuccessParam = new URLSearchParams(window.location.search).get('customer_posted');
  if (nlSuccessParam === 'true') {
    document.querySelectorAll('.nl-form').forEach(form => {
      const sub = document.createElement('p');
      sub.className = 'nl-success';
      sub.textContent = 'You are now part of the inner circle.';
      sub.style.cssText = 'font-family:var(--sans);font-size:13px;color:var(--sage,#6E7D62);margin-top:16px;letter-spacing:.5px;';
      form.after(sub);
      form.style.display = 'none';
    });
  }

  // ── Mobile nav toggle ─────────────────────────
  const mobileToggle = document.querySelector('.mobile-nav-toggle');
  const mobileNav = document.querySelector('.mobile-nav');
  if (mobileToggle && mobileNav) {
    mobileToggle.addEventListener('click', () => {
      const isOpen = mobileNav.classList.toggle('open');
      mobileToggle.setAttribute('aria-expanded', String(isOpen));
      mobileToggle.setAttribute('aria-label', isOpen ? 'Close menu' : 'Open menu');
      mobileToggle.classList.toggle('is-open', isOpen);
      document.body.style.overflow = isOpen ? 'hidden' : '';
    });
    // Close mobile nav on ESC
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && mobileNav.classList.contains('open')) {
        mobileNav.classList.remove('open');
        mobileToggle.setAttribute('aria-expanded', 'false');
        mobileToggle.setAttribute('aria-label', 'Open menu');
        mobileToggle.classList.remove('is-open');
        document.body.style.overflow = '';
        mobileToggle.focus();
      }
    });
  }

  // ── Collections mega-dropdown: close on outside click ─────
  document.querySelectorAll('.nav-has-dropdown').forEach(wrap => {
    const trigger = wrap.querySelector('a');
    const mega    = wrap.querySelector('.nav-mega');
    if (!trigger || !mega) return;

    // Update aria-expanded on hover
    wrap.addEventListener('mouseenter', () => trigger.setAttribute('aria-expanded', 'true'));
    wrap.addEventListener('mouseleave', () => trigger.setAttribute('aria-expanded', 'false'));

    // Keyboard: open with Enter/Space, close with Escape
    trigger.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        const isExpanded = trigger.getAttribute('aria-expanded') === 'true';
        trigger.setAttribute('aria-expanded', String(!isExpanded));
        mega.style.cssText = isExpanded
          ? '' : 'opacity:1;visibility:visible;pointer-events:auto;transform:translateX(-50%) translateY(0)';
      }
      if (e.key === 'Escape') {
        trigger.setAttribute('aria-expanded', 'false');
        mega.style.cssText = '';
        trigger.focus();
      }
    });

    // Trap focus inside mega on Tab
    mega.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        trigger.setAttribute('aria-expanded', 'false');
        mega.style.cssText = '';
        trigger.focus();
      }
    });
  });

  // Close all dropdowns when clicking outside the nav
  document.addEventListener('click', (e) => {
    if (!e.target.closest('.nav-has-dropdown')) {
      document.querySelectorAll('.nav-has-dropdown a[aria-expanded="true"]').forEach(t => {
        t.setAttribute('aria-expanded', 'false');
      });
    }
  });

  // ── Product page: thumbnail gallery switcher ────────────
  const featuredImg = document.getElementById('pp-featured-img');
  document.querySelectorAll('.pp-thumb').forEach(thumb => {
    thumb.addEventListener('click', function() {
      if (!featuredImg) return;
      document.querySelectorAll('.pp-thumb').forEach(t => t.classList.remove('active'));
      this.classList.add('active');
      featuredImg.style.opacity = '0';
      const newSrc  = this.dataset.src  || '';
      const newAlt  = this.dataset.alt  || '';
      // Wait for CSS fade-out (220ms) to finish, then swap src.
      // Only reveal the image once it has fully loaded — this prevents
      // the old image flashing back briefly before the new one is ready.
      setTimeout(() => {
        featuredImg.onload = () => { featuredImg.style.opacity = '1'; };
        featuredImg.src = newSrc;
        featuredImg.alt = newAlt;
        // Rebuild srcset so browser picks correct resolution
        if (newSrc) {
          featuredImg.srcset = [
            newSrc.replace(/width=\d+/, 'width=600')  + ' 600w',
            newSrc.replace(/width=\d+/, 'width=1000') + ' 1000w',
            newSrc.replace(/width=\d+/, 'width=1400') + ' 1400w'
          ].join(', ');
        }
        // If the browser already has this image cached, onload won't fire —
        // handle that case by checking .complete immediately after setting src.
        if (featuredImg.complete) { featuredImg.style.opacity = '1'; }
      }, 240);
    });
  });

  // ── Hero image carousel ───────────────────────
  document.querySelectorAll('.hero-carousel').forEach(carousel => {
    const slides = carousel.querySelectorAll('.hero-slide');
    const dots   = carousel.querySelectorAll('.carousel-dot');
    const prev   = carousel.querySelector('.carousel-prev');
    const next   = carousel.querySelector('.carousel-next');
    if (slides.length <= 1) return;

    let current = 0;
    const speed = parseInt(carousel.dataset.speed) || 5000;

    function goTo(idx) {
      slides[current].classList.remove('active');
      dots[current]?.classList.remove('active');
      current = (idx + slides.length) % slides.length;
      slides[current].classList.add('active');
      dots[current]?.classList.add('active');
    }

    // Respect prefers-reduced-motion — no auto-advance for users who prefer it
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // Auto-advance
    let timer = prefersReducedMotion ? null : setInterval(() => goTo(current + 1), speed);

    const resetTimer = () => {
      if (prefersReducedMotion) return;
      clearInterval(timer);
      timer = setInterval(() => goTo(current + 1), speed);
    };

    prev?.addEventListener('click', () => { goTo(current - 1); resetTimer(); });
    next?.addEventListener('click', () => { goTo(current + 1); resetTimer(); });
    dots.forEach((dot, i) => dot.addEventListener('click', () => { goTo(i); resetTimer(); }));

    // Pause on hover
    carousel.addEventListener('mouseenter', () => clearInterval(timer));
    carousel.addEventListener('mouseleave', () => {
      if (!prefersReducedMotion) timer = setInterval(() => goTo(current + 1), speed);
    });

    // Pause when tab is hidden, resume when visible
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        clearInterval(timer);
      } else if (!prefersReducedMotion) {
        timer = setInterval(() => goTo(current + 1), speed);
      }
    });

    // Touch/swipe support for mobile (Issue 11)
    let touchStartX = 0;
    let touchStartY = 0;
    carousel.addEventListener('touchstart', e => {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
    }, { passive: true });
    carousel.addEventListener('touchend', e => {
      const diff = touchStartX - e.changedTouches[0].clientX;
      const diffY = touchStartY - e.changedTouches[0].clientY;
      if (Math.abs(diff) > 50 && Math.abs(diff) > Math.abs(diffY)) {
        goTo(diff > 0 ? current + 1 : current - 1);
        resetTimer();
      }
    }, { passive: true });
  });

  // ── Journal: Load More ──────────────────────
  var jnlBtn = document.getElementById('jnl-load-more');
  if (jnlBtn) {
    var jnlPage = 1;
    var jnlTotalPages = parseInt(jnlBtn.dataset.totalPages, 10);

    jnlBtn.addEventListener('click', function() {
      jnlPage++;
      jnlBtn.textContent = 'Loading…';
      jnlBtn.disabled = true;

      fetch(window.location.pathname + '?page=' + jnlPage)
        .then(function(r) { return r.text(); })
        .then(function(html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var newCards = doc.querySelectorAll('.jcard');
          var grid = document.getElementById('jnl-grid');
          newCards.forEach(function(card) {
            grid.appendChild(card);
            io.observe(card);
          });

          var shown = grid.querySelectorAll('.jcard').length;
          var total = parseInt(jnlBtn.dataset.total, 10);

          if (jnlPage >= jnlTotalPages) {
            jnlBtn.textContent = 'All ' + total + ' articles shown';
            jnlBtn.disabled = true;
            jnlBtn.classList.add('jnl-load-btn--done');
          } else {
            jnlBtn.textContent = 'Load more — showing ' + shown + ' of ' + total;
            jnlBtn.disabled = false;
          }
        })
        .catch(function() {
          jnlBtn.textContent = 'Try again';
          jnlBtn.disabled = false;
        });
    });
  }

});
